import React from "react";
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import axios from "axios";
import "./app.css";
import Home from "./pages/home/home";
import "./component/fontawesome/css/all.min.css"

const App = () => {

  return (
    <Routes>
      <Route path="/" element={<Home page="home" />} />

      <Route path="/gps" element={<Home page="gps" />} />
      <Route path="/gps-nukus" element={<Home page="gps_nukus" />} />
      <Route path="/gps-khorezm" element={<Home page="gps_khorezm" />} />
      <Route path="/gps-urgench" element={<Home page="gps_urgench" />} />

      <Route path="/fuel-control" element={<Home page="fuel" />} />
      <Route path="/fuel-sensor" element={<Home page="sensor" />} />

      <Route path="/wialon" element={<Home page="wialon" />} />
      <Route path="/teltonika" element={<Home page="teltonika" />} />
      <Route path="/fmb920" element={<Home page="fmb920" />} />
      <Route path="/fmb125" element={<Home page="fmb125" />} />
      <Route path="/escort" element={<Home page="escort" />} />

      <Route path="/video" element={<Home page="video" />} />
      <Route path="/camera-install" element={<Home page="camera_install" />} />
      <Route path="/hikvision" element={<Home page="hikvision" />} />
      <Route path="/dahua" element={<Home page="dahua" />} />
      <Route path="/faceid" element={<Home page="faceid" />} />
      <Route path="/turnstile" element={<Home page="turnstile" />} />
      <Route path="/warehouse-camera" element={<Home page="warehouse" />} />
      <Route path="/office-camera" element={<Home page="office" />} />
      <Route path="/truck-camera" element={<Home page="truck" />} />

      <Route path="/fleet" element={<Home page="fleet" />} />
      <Route path="/logistics" element={<Home page="logistics" />} />

      <Route path="/contacts" element={<Home page="contacts" />} />
      <Route path="/about" element={<Home page="about" />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
